/** CSS variables for the Mars service's visual theme. */
export const theme = {
  '--basefont': '"Exo 2", sans-serif',
  '--primary-darken': 'var(--mars-orange-dark)',
  '--primary': '#a75233' /* variable semantica para color corporativo */,
  '--charcoal-grey': 'var(--charcoal-grey)',
  '--mars-black': 'var(--charcoal-grey)',
  '--mars-orange': '#a75233',
  '--mars-orange-dark': '#652e19',
  '--kepler-green': '#0e9db3',
  '--kepler-green-dark': '#0a7485'
};
